import { render, staticRenderFns } from "./PlantMyPlants.vue?vue&type=template&id=20565063&scoped=true"
import script from "./PlantMyPlants.vue?vue&type=script&lang=ts"
export * from "./PlantMyPlants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20565063",
  null
  
)

export default component.exports